export const CampaignType = {
  None: 0,
  Default: 0b1,
  Shopping: 0b10,
  DynamicSearchAds: 0b100,
  Audience: 0b1000,
  Smart: 0b10000,
  Hotel: 0b100000,
  PerformanceMax: 0b1000000,
  App: 0b10000000,
  LinkedIn: 0b100000000,
  ObjectiveBased: 0b1000000000,
  All: 0xFFFF,
};

export const CampaignTypeByEnumValue = {
  "Enum.CampaignType'Default'": CampaignType.Default,
  "Enum.CampaignType'Shopping'": CampaignType.Shopping,
  "Enum.CampaignType'DynamicSearchAds'": CampaignType.DynamicSearchAds,
  "Enum.CampaignType'Audience'": CampaignType.Audience,
  "Enum.CampaignType'Smart'": CampaignType.Smart,
  "Enum.CampaignType'Hotel'": CampaignType.Hotel,
  "Enum.CampaignType'PerformanceMax'": CampaignType.PerformanceMax,
  "Enum.CampaignType'App'": CampaignType.App,
  "Enum.CampaignType'LinkedIn'": CampaignType.LinkedIn,
  "Enum.CampaignType'ObjectiveBased'": CampaignType.ObjectiveBased,
};

export const CampaignTypeToStringMap = {
  [CampaignType.Default]: 'Default',
  [CampaignType.Shopping]: 'Shopping',
  [CampaignType.DynamicSearchAds]: 'DynamicSearchAds',
  [CampaignType.Audience]: 'Audience',
  [CampaignType.Smart]: 'Smart',
  [CampaignType.Hotel]: 'Hotel',
  [CampaignType.PerformanceMax]: 'PerformanceMax',
  [CampaignType.App]: 'App',
  [CampaignType.LinkedIn]: 'LinkedIn',
  [CampaignType.ObjectiveBased]: 'ObjectiveBased',
  [CampaignType.All]: 'All',
} as const;

export const CampaignTypeToLocalizationMap = {
  [CampaignType.Default]: _TL_('Search'),
  [CampaignType.Shopping]: _TL_('Shopping'),
  [CampaignType.DynamicSearchAds]: _TL_('DynamicSearchAds'),
  [CampaignType.Audience]: _TL_('Audience'),
  [CampaignType.Smart]: _TL_('Smart'),
  [CampaignType.Hotel]: _TL_('Hotel'),
  [CampaignType.PerformanceMax]: _TL_('PerformanceMax'),
  [CampaignType.App]: _TL_('App'),
  [CampaignType.LinkedIn]: _TL_('LinkedIn'),
  [CampaignType.ObjectiveBased]: _TL_('Objective-based'),
  [CampaignType.All]: _TL_('All'),
};

export const CampaignTypeByODataValue = {
  Default: CampaignType.Default,
  Shopping: CampaignType.Shopping,
  DynamicSearchAds: CampaignType.DynamicSearchAds,
  Audience: CampaignType.Audience,
  Smart: CampaignType.Smart,
  Hotel: CampaignType.Hotel,
  PerformanceMax: CampaignType.PerformanceMax,
  App: CampaignType.App,
  LinkedIn: CampaignType.LinkedIn,
  ObjectiveBased: CampaignType.ObjectiveBased,
};
